import type { RouteObject } from 'react-router';

import { createPaths } from '@ricoh/ria.client.core/utils/router/path';

/** Unverified User route. */
const unverifiedUserRoute: RouteObject = {
  lazy: async () => (await import('~/components/layout/welcome')).default,

  children: [
    // Verify Identity
    {
      path: 'verify-identity',
      lazy: async () => (await import('~/components/page/unverified-user/verify-identity')).default,
    },
  ],
};

/** Unverified User paths. */
export const unverifiedUserPaths = createPaths(unverifiedUserRoute);

export default unverifiedUserRoute;
